"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringQuerySchema = exports.QuerySchema = exports.QueryVariableSchema = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
Object.defineProperty(exports, "QueryVariableSchema", { enumerable: true, get: function () { return _shared_1.QueryVariableSchema; } });
// Zod schema for AthenaConfig.Query
exports.QuerySchema = _imports_1.z.object({
    /** These variables can be used in binding formulas */
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    /**
     * Elements to be bound to the queryString when generating SQL.
     * The order and quantity of elements matter since utilizing array!
     * Can consider updating this to use map with identifiers instead
     */
    bindings: _imports_1.z.array(_imports_1.z.string()),
    /** Athena "queryString" that is parameterized with '?' and uses "bindings" */
    query: _imports_1.z.object({
        name: _imports_1.z.string(),
        queryString: _imports_1.z.string(),
    }),
    /**
     * These columnNames are the output from after running the query.
     * They will be made available for later references (e.g., intermediate fields)
     */
    columnNames: _imports_1.z.array(_imports_1.z.string()),
});
// Zod schema for AthenaConfig.RecurringQuery
exports.RecurringQuerySchema = _imports_1.z.object({
    /** Name that would be used for the variable outputs */
    name: _imports_1.z.string(),
    /**
     * This would house "field" value from "globalRecurringDateConfigs" to help
     * denote which one it is referencing to use at time of generation
     */
    globalRecurringDateConfigFields: _imports_1.z.array(_imports_1.z.string()),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    /**
     * For recurring dates: can just directly reference the "field" that is
     * set in "globalRecurringDateConfigs" and utilize that "field" as just
     * a normal variable.
     */
    bindings: _imports_1.z.array(_imports_1.z.string()),
    /**
     * Continuing with above example, can simply set string like:
     * SELECT date, exposure from TABLE where reportingDate = ?
     */
    queryString: _imports_1.z.string(),
    /**
     * Same attribute as normal "query", this helps with eagerly storing the columnNames,
     * which ultimately become the variable outputs of the query for subsequent references.
     */
    columnNames: _imports_1.z.array(_imports_1.z.string()),
    /**
     * Note that this "defaultTo" will apply to all the columns if
     * a recurringDate index doesn't exist.
     */
    defaultTo: _imports_1.z.object({
        value: _imports_1.z.string(),
        parseString: _imports_1.z.boolean(),
    }),
});
//# sourceMappingURL=AthenaConfig.js.map